import { ProductPrice } from '@components/common/ProductPrice/ProductPrice'
import Link from 'next/link'
import { number, shape, string } from 'prop-types'
import React from 'react'
import { mergeClasses } from '../PageBuilder/classify'
import { makeOptimizedUrl as resourceUrl } from '../PageBuilder/makeUrl'
import cn from 'classnames'
import defaultClasses from './item.module.scss'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

// The placeholder image is 4:5, so we should make sure to size our product
// images appropriately.
const IMAGE_WIDTH = 300

// Gallery switches from two columns to three at 640px.
const IMAGE_SIZE_BREAKPOINTS = new Map()
IMAGE_SIZE_BREAKPOINTS.set('small', 640)

const IMAGE_SIZES = new Map()
IMAGE_SIZES.set('small', IMAGE_WIDTH)
IMAGE_SIZES.set('medium', 840)

const ItemPlaceholder = ({ classes }) => (
    <div className={classes.root_pending}>
        {/* eslint-disable-next-line i18next/no-literal-string */}
        <div className={classes.images_pending}>Place Holder Image</div>
        <div className={classes.name_pending} />
        <div className={classes.price_pending} />
    </div>
)

const GalleryItem = (props) => {
    const { item, AddToWishlist, AddToWishlistLabel, globalOptions } = props

    const classes = mergeClasses(defaultClasses, props.classes)
    const { name, price_range = {}, small_image, url_key } = item || {}
    const config = useStoreConfig()

    if (!item) {
        return <ItemPlaceholder classes={classes} />
    }

    const productUrlSuffix = config.base?.url?.model?.product?.suffix

    const productLink = resourceUrl(`/${url_key}${productUrlSuffix}`)

    return (
        <div className={cn(classes.root, 'product-item')}>
            {AddToWishlist && (
                <div data-role="add-to-links" className="actions-secondary">
                    <AddToWishlist
                        productId={item.id}
                        qty={1}
                        labelText={
                            <AddToWishlistLabel width={31} height={20} />
                        }
                        isMultiWishlist={false}
                    />
                </div>
            )}
            <Link
                href={`/product${productLink}`}
                className={classes.images}
                aria-label={name}
            >
                {/* <FadeIn height={100}> */}
                {/* {onload => ( */}
                <img src={small_image} alt={name} onLoad={onload} />
                {/* )} */}
                {/* </FadeIn> */}
            </Link>
            <h4 className="item-name">
                <Link href={`/product${productLink}`}>{name}</Link>
            </h4>
            <div className="item-price">
                <ProductPrice priceRange={price_range} />
            </div>
        </div>
    )
}

GalleryItem.propTypes = {
    classes: shape({
        image: string,
        imageContainer: string,
        imagePlaceholder: string,
        image_pending: string,
        images: string,
        images_pending: string,
        name: string,
        name_pending: string,
        price: string,
        price_pending: string,
        root: string,
        root_pending: string
    }),
    item: shape({
        id: number.isRequired,
        name: string.isRequired,
        small_image: string.isRequired,
        url_key: string.isRequired,
        price_range: shape({
            minimum_price: shape({
                final_price: shape({
                    value: number.isRequired,
                    currency: string.isRequired
                }).isRequired
            }).isRequired
        }).isRequired
    })
}

export default GalleryItem
